import { render } from "./button-accordion.vue?vue&type=template&id=a2dd6fda&ts=true"
import script from "./button-accordion.vue?vue&type=script&lang=ts"
export * from "./button-accordion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__